import { useQuery } from '@tanstack/react-query'

import { BarChartWidget } from '@/components/dashboard/widgets/BarChartWidget'
import { StatusBadgeGroupWidget } from '@/components/dashboard/widgets/StatusBadgeGroupWidget'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { getDeveloperAnalytics } from '@/services/api/developer.service'

export function DeveloperAnalyticsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['developer', 'analytics'],
    queryFn: getDeveloperAnalytics,
  })

  if (isLoading) {
    return <div className="text-neutral-500">Loading analytics...</div>
  }

  if (!data) {
    return <div className="text-neutral-500">No analytics available.</div>
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Developer Analytics</h1>
        <p className="mt-1 text-neutral-500">System-wide growth and adoption metrics.</p>
      </div>

      <div className="grid gap-4 xl:grid-cols-4">
        {Object.entries(data.summary).map(([key, value]) => (
          <Card key={key}>
            <CardHeader><CardTitle className="text-sm text-neutral-500">{key}</CardTitle></CardHeader>
            <CardContent><div className="text-3xl font-bold">{String(value)}</div></CardContent>
          </Card>
        ))}
      </div>

      <div className="grid gap-6 xl:grid-cols-2">
        <BarChartWidget title="Plan Distribution" data={data.planCounts} />
        <StatusBadgeGroupWidget title="Workspace Statuses" data={data.workspaceStatusCounts.map((item) => ({ label: String(item.workspaceName), value: String(item.status) }))} />
      </div>

      <BarChartWidget title="Record Growth (30 days)" data={data.recordGrowth} />
    </div>
  )
}
